<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.autorizador"
        ref="RkmDataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                @click="edit(item.id)"
                authorize="update-cadastro-autorizador"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="!!item.ativo"
                @click="deactivate(item.id)"
                authorize="update-cadastro-autorizador"
                color="dark"
                small
                title="Inativar"
            >
                <rkm-icon icon="ban" />
            </rkm-button>

            <rkm-button
                v-else
                @click="activate(item.id)"
                authorize="update-cadastro-autorizador"
                color="success"
                small
                title="Ativar"
            >
                <rkm-icon icon="check-circle" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {key: 'nome', name: 'cidadao.nome', label: 'Profissional', searchable: true, sortable: true},
                {key: 'cns', name: 'cidadao.cns', label: 'CNS', searchable: true, sortable: true},
                {class: 'col-min text-center', key: 'situacao', label: 'Situação'},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    created() {
        this.repositories = {
            autorizador: this.getConectaSusRepository('cadastro.autorizador')
        }
    },
    methods: {
        edit(id) {
            this.$router.push({name: 'cadastro-autorizador-edit', params: {id: id}})
        },
        activate(id) {
            const activate = () => this.repositories.autorizador.activate(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.createNotification({
                color: 'success',
                confirm: activate,
                message: 'Deseja realmente ativar o autorizador?',
                onError: this.handleError,
                title: 'Confirmação de ativação',
                type: 'dialog',
            })
        },
        deactivate(id) {
            const deactivate = () => this.repositories.autorizador.deactivate(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.createNotification({
                color: 'danger',
                confirm: deactivate,
                message: 'Deseja realmente inativar o autorizador?',
                onError: this.handleError,
                title: 'Confirmação de inativação',
                type: 'dialog',
            })
        },
    },
    mixins: [ error, repository ],
}
</script>
